import { CanDeactivateFn } from '@angular/router';
import { Observable } from 'rxjs';

// This interface will be implemented by components that need to check for unsaved changes
export interface CanComponentDeactivate {
  canDeactivate: () => boolean | Observable<boolean>;
}

// Define the canDeactivate guard function
export const unsavedChangesGuard: CanDeactivateFn<CanComponentDeactivate> = (component) => {
  // Check if the component has implemented the canDeactivate method
  if (component.canDeactivate) {
    // Call the component's canDeactivate method, which can return a boolean or Observable
    return component.canDeactivate();
  }
  // If no check is needed, allow navigation
  return true;
};
